
import {getWebServiceVersions } from '@/services/endpoints/webServiceVersions'

export default {

    async getWebServiceVersions({ commit }) {
        try {
            let res = await getWebServiceVersions();
            if(res) {
                return res.data;
            }else{
                throw new Error('err')

            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
}